{
  "common": {
    "actions": {
      "save": "Speichern",
      "edit": "Bearbeiten",
      "saveChanges": "Änderungen speichern",
      "saveAndExit": "Speichern und beenden",
      "cancel": "Abbrechen",
      "back": "Zurück",
      "delete": "Löschen",
      "reject": "Ablehnen",
      "accept": "Akzeptieren",
      "add": "Hinzufügen",
      "applyChanges": "Änderungen übernehmen",
      "preview": "Vorschau",
      "close": "Schließen",
      "revert": "Rückgängig machen",
      "clickHere": "Hier klicken",
      "continue": "Weiter",
      "export": "Exportieren",
      "learnMore": "Mehr erfahren",
      "previous": "Zurück",
      "next": "Weiter",
      "complete": "Abschließen",
      "change": "Ändern"
    },
    "statuses": {
      "canceled": "Abgebrochen",
      "rejected": "Abgelehnt",
      "accepted": "Akzeptiert",
      "success": "Erfolgreich",
      "failed": "Fehlgeschlagen",
      "required": "Erforderlich",
      "open": "Offen",
      "closed": "Geschlossen",
      "imported": "Importiert",
      "draft": "Entwurf",
      "forReview": "Zur Prüfung",
      "forApproval": "Zur Genehmigung",
      "approved": "Genehmigt",
      "approvalDeclined": "Genehmigung abgelehnt",
      "effective": "Wirksam",
      "superseded": "Ersetzt"
    },
    "labels": {
      "archivedRegistryItem": "{{name}} (Archiviert)",
      "deactivatedUser": "{{name}} (Deaktiviert)",
      "name": "Name",
      "type": "Typ",
      "email": "E-Mail",
      "password": "Passwort",
      "comments": "Kommentare",
      "properties": "Eigenschaften",
      "assignedTo": "Zugewiesen an",
      "eventTitle": "Ereignistitel",
      "eventId": "Ereignis-ID",
      "none": "Keine",
      "reason": "Grund",
      "events": "Ereignisse",
      "created": "Erstellt",
      "lastModified": "Zuletzt geändert",
      "steps": "Schritte",
      "fields": "Felder",
      "version": "Version",
      "owner": "Besitzer",
      "eventType": "Ereignistyp",
      "eventTypes": "Ereignistypen",
      "taskStatus": "Aufgabenstatus",
      "createdBetween": "Erstellt zwischen",
      "due": "Fällig",
      "status": "Status",
      "owners": "Besitzer",
      "startDate": "Startdatum",
      "endDate": "Enddatum",
      "risk": "Risiko",
      "severity": "Schweregrad",
      "ownerEmail": "E-Mail des Besitzers",
      "probability": "Wahrscheinlichkeit",
      "product": "Produkt",
      "products": "Produkte",
      "rootCause": "Ursache",
      "rootCauses": "Ursachen",
      "relatedRecords": "Beziehungen",
      "source": "Quelle",
      "assignee": "Beauftragter",
      "description": "Beschreibung",
      "visible": "Sichtbar",
      "required": "Erforderlich",
      "title": "Titel",
      "prefix": "Präfix",
      "attachments": "Anhänge",
      "resolution": "Lösung",
      "relatedTo": "Bezieht sich auf",
      "approvers": "Genehmiger",
      "reviewers": "Prüfer",
      "total": "Gesamt",
      "approvalDate": "Genehmigungsdatum",
      "id": "ID",
      "tags": "Tags",
      "emptyProducts": "Leere Produkte",
      "emptyRootCauses": "Leere Ursachen",
      "emptyTags": "Leere Tags",
      "emptySeverities": "Leere Schweregrade",
      "emptyProbabilities": "Leere Wahrscheinlichkeiten",
      "suppliers": "Lieferanten",
      "dueDate": "Fälligkeitsdatum",
      "currentDueDate": "Aktuelles Fälligkeitsdatum",
      "newDueDate": "Neues Fälligkeitsdatum",
      "selectANewOwner": "Neuen Besitzer auswählen",
      "tasks": "Aufgaben",
      "usersList": "Benutzerliste",
      "createdBefore": "Erstellt vor",
      "createdAfter": "Erstellt nach",
      "dueAfter": "Fällig nach",
      "dueBefore": "Fällig vor",
      "resolvedAfter": "Gelöst nach",
      "resolvedBefore": "Gelöst vor",
      "overdue": "Überfällig",
      "onTime": "Pünktlich",
      "integrationVariables": "Integrationsvariablen",
      "comment": "Kommentar",
      "currentOwner": "Aktueller Besitzer",
      "newOwner": "Neuer Besitzer",
      "defaultSections": "Standardabschnitte",
      "formSteps": "Formularschritte",
      "capturedIn": "Erfasst in",
      "inSection": "Im Abschnitt",
      "open": "Offen",
      "canceled": "Abgebrochen",
      "completed": "Abgeschlossen",
      "templateOwner": "Vorlagenverantwortlicher",
      "timeLimitDays": "Zeitlimit (Tage)",
      "validationStepTimeDelayDays": "Zeitverzögerung Validierungsschritt (Tage)",
      "newTemplateOwner": "Neuer Vorlagenverantwortlicher",
      "defaultContent": "Standardinhalt",
      "sectionWithPosition": "Abschnitt {{position}}",
      "back": "Zurück",
      "moveUp": "Nach oben",
      "moveDown": "Nach unten",
      "yes": "Ja",
      "no": "Nein",
      "view": "Anzeigen",
      "resolved": "Gelöst",
      "closed": "Geschlossen",
      "imported": "Importiert",
      "manage": "Verwalten",
      "emptyState": "--",
      "order": "Reihenfolge",
      "fullName": "Vollständiger Name",
      "groups": "Gruppen",
      "taskName": "Aufgabenname",
      "approve": "Genehmigen",
      "decline": "Ablehnen",
      "revert": "Zurücksetzen",
      "eventClosed": "Ereignis geschlossen",
      "stepCompleted": "Schritt abgeschlossen",
      "stepReverted": "Schritt zurückgesetzt",
      "eventReopened": "Ereignis wieder geöffnet",
      "reviewersAssigned": "Prüfer zugewiesen!",
      "approversAssigned": "Genehmiger zugewiesen!",
      "and": "und",
      "content": "Inhalt",
      "form": "Formular",
      "validationWithType": "Validierung ({{type}})",
      "reopen": "Wieder öffnen",
      "qualityApproverRequired": "Qualitätsgenehmiger erforderlich"
    },
    "placeholders": {
      "email": "E-Mail...",
      "password": "Passwort...",
      "enterANumber": "Zahl eingeben",
      "writeAComment": "Kommentar schreiben...",
      "searchFor": "Nach {{domain}} suchen, um hinzuzufügen...",
      "noResults": "Keine Ergebnisse",
      "startTypingToSearchFor": "Beginnen Sie mit der Eingabe, um zu suchen nach",
      "newestFirst": "Neueste zuerst",
      "oldestFirst": "Älteste zuerst"
    },
    "errors": {
      "defaultErrorMessage": "Bei der Kommunikation mit dem Server ist ein Problem aufgetreten.",
      "timeZoneMissingMessage": "Die Zeitzone des Benutzers konnte nicht gefunden werden.",
      "invalidCredentials": "Ungültige Zugangsdaten",
      "somethingHasGoneWrong": "Etwas ist schiefgelaufen!",
      "currentCompanyRoleError": "Die Rolle des Benutzers in der aktuellen Instanz konnte nicht ermittelt werden.",
      "failedToFetchEventDetails": "Ereignisdetails konnten nicht abgerufen werden.",
      "duplicateTitlesNotAllowed": "Doppelte Titel sind nicht erlaubt. Bitte verwenden Sie eindeutige Titel.",
      "invalidCharactersInTitle": "Ungültige Zeichen im Titel: {{characters}}",
      "missingRequiredFieldsClickHere": "Es fehlen einige erforderliche Felder im Ereignis. Klicken Sie hier, um die erforderlichen Ereignisfelder anzuzeigen.",
      "missingRequiredFieldsWithPrefix": "...Ereignis. Klicken Sie hier, um die erforderlichen Ereignisfelder anzuzeigen.",
      "invalidCharactersInTitlePrefix": "Ungültige Zeichen im Titel:"
    },
    "notifications": {
      "fileReady": "Datei bereit",
      "preparingFileForDownload": "Datei wird für den Download vorbereitet",
      "error": "Fehler",
      "userReassigned": "Benutzer neu zugewiesen",
      "eventCreated": "Ereignis erstellt",
      "missingInformation": "Fehlende Informationen",
      "success": "Erfolg",
      "draftDeleted": "Entwurf gelöscht",
      "draftNotDeleted": "Entwurf nicht gelöscht",
      "ownerChanged": "Besitzer geändert",
      "ownerNotChanged": "Besitzer nicht geändert",
      "eventOpened": "Ereignis geöffnet",
      "eventNotOpened": "Ereignis nicht geöffnet",
      "eventUpdated": "Ereignis aktualisiert",
      "eventNotUpdated": "Ereignis nicht aktualisiert",
      "taskCompleted": "Aufgabe abgeschlossen",
      "taskNotCompleted": "Aufgabe nicht abgeschlossen",
      "failed": "Fehlgeschlagen",
      "tagsUpdated": "Tags aktualisiert",
      "tagsNotUpdated": "Tags nicht aktualisiert",
      "eventPropertiesUpdated": "Ereigniseigenschaften aktualisiert",
      "newEventCreated": "Neues Ereignis erstellt",
      "eventNotCreated": "Ereignis nicht erstellt",
      "couldNotRetrieveEventMetadata": "Ereignis-Metadaten konnten nicht abgerufen werden",
      "couldNotRetrieveGroups": "Gruppen konnten nicht abgerufen werden",
      "failedToFetchEventTemplateDetails": "Details der Ereignisvorlage konnten nicht abgerufen werden",
      "eventUpdateFailed": "Ereignisaktualisierung fehlgeschlagen",
      "revertedToDraft": "In Entwurf zurückgesetzt",
      "changesSaved": "Änderungen gespeichert",
      "failedToUpdateTask": "Aufgabe konnte nicht aktualisiert werden",
      "couldNotRetrieveTags": "Tags konnten nicht abgerufen werden",
      "couldNotRetrieveUsers": "Benutzer konnten nicht abgerufen werden",
      "reviewed": "Geprüft",
      "stepNotReviewed": "Schritt nicht geprüft",
      "eventReassignmentFailed": "Neuzuweisung des Ereignisses fehlgeschlagen",
      "couldNotRetrieveEventTypes": "Ereignistypen konnten nicht abgerufen werden",
      "failedToFetchFormTemplateDetails": "Details der Formularvorlage konnten nicht abgerufen werden",
      "formTemplateUpdateFailed": "Aktualisierung der Formularvorlage fehlgeschlagen",
      "eventTemplateUpdated": "Ereignisvorlage aktualisiert",
      "eventTemplateNotUpdated": "Ereignisvorlage nicht aktualisiert",
      "newDraftCreated": "Neuer Entwurf erstellt",
      "creatingNewDraftFailed": "Erstellung eines neuen Entwurfs fehlgeschlagen",
      "templateArchived": "Vorlage archiviert",
      "templateArchivingFailed": "Archivierung der Vorlage fehlgeschlagen",
      "templateRestored": "Vorlage wiederhergestellt",
      "templateRestoringFailed": "Wiederherstellung der Vorlage fehlgeschlagen",
      "missingRequiredFields": "Fehlende Pflichtfelder",
      "temporarilyUnableToRetrieveAllEventProperties": "Vorübergehend nicht in der Lage, alle Ereigniseigenschaften abzurufen",
      "reviewRequest": "Prüfungsanfrage",
      "yourReviewIsRequired": "Ihre Prüfung ist erforderlich",
      "fileReadyToDownloadPrefix": "Die Datei steht jetzt zum",
      "fileReadyToDownloadLinkText": "Herunterladen",
      "couldNotRetrieveSummaryFromAI": "Zusammenfassung konnte nicht vom KI‑Dienst abgerufen werden",
      "propertiesUpdateForEvent": "Eigenschaften für Ereignis {{eventCode}} erfolgreich aktualisiert",
      "eventCreatedDesc": "\"{{eventCode}} | {{eventTitle}}\" wurde erstellt",
      "eventCreatedWithTitle": "\"{{title}}\" wurde erstellt",
      "tagsUpdatedDesc": "Tags für {{eventCode}} erfolgreich aktualisiert",
      "eventUpdatedToLatestTemplate": "Ereignis wurde auf die neueste Ereignisvorlage aktualisiert.",
      "eventNotUpdatedToLatestTemplate": "Ereignis wurde nicht auf die neueste Ereignisvorlage aktualisiert.",
      "draftSuccessfullyDeleted": "Der Entwurf wurde erfolgreich gelöscht",
      "failedToDeleteTheDraft": "Entwurf konnte nicht gelöscht werden",
      "pleaseSaveTheEventTemplateFirst": "Bitte speichern Sie zuerst die Ereignisvorlage",
      "wellLetYouKnowWhenFileIsReady": "Wir benachrichtigen Sie, wenn die Datei bereit ist",
      "exportingEventCodeTitle": "Exportiere {{code}} {{title}}",
      "ownerSuccessfullyChanged": "Besitzer für {{eventCode}} erfolgreich geändert",
      "theTeamHasBeenNotified": "Das Team wurde benachrichtigt. Bitte aktualisieren Sie die Seite oder versuchen Sie es später erneut."
    },
    "filters": {
      "filterByOwner": "Nach Besitzer filtern...",
      "filterByCollaborator": "Nach Mitwirkenden filtern...",
      "filterByAssignee": "Nach Beauftragtem filtern...",
      "filterByCreatedDate": "Nach Erstellungsdatum filtern...",
      "filterByDueDate": "Nach Fälligkeitsdatum filtern...",
      "filterByResolvedDate": "Nach Lösungsdatum filtern...",
      "filterByDueStatus": "Nach Fälligkeit filtern...",
      "filterByProduct": "Nach Produkt filtern...",
      "filterByRootCause": "Nach Ursache filtern...",
      "filterByTags": "Nach Tags filtern...",
      "filterByProbability": "Nach Wahrscheinlichkeit filtern...",
      "filterByNameEmailOrGroupName": "Nach Name, E-Mail oder Gruppe filtern...",
      "filterBySeverity": "Nach Schweregrad filtern...",
      "searchRelatedRecords": "Nach Beziehungen filtern...",
      "searchMore": "Weitere suchen...",
      "filterByStatus": "Nach Status filtern...",
      "filterByEventType": "Nach Ereignistyp filtern...",
      "approversAdded": "Genehmiger hinzugefügt",
      "approversRemoved": "Genehmiger entfernt",
      "reviewersAdded": "Prüfer hinzugefügt",
      "reviewersRemoved": "Prüfer entfernt",
      "reasonForRemovingTheUserType": "Grund für das Entfernen der {{userType}}..."
    },
    "tables": {
      "noMatchingEventsFound": "Keine passenden Ereignisse gefunden",
      "noMatchingTasksFound": "Keine passenden Aufgaben gefunden"
    },
    "pagination": {
      "show": "Anzeigen",
      "showSpace": "Anzeigen ",
      "previousPage": "Vorherige Seite",
      "nextPage": "Nächste Seite"
    },
    "exports": {
      "fileReady": "Datei bereit",
      "preparingFileForDownload": "Datei wird für den Download vorbereitet",
      "failedToExportTheFile": "Datei konnte nicht exportiert werden.",
      "xlsx": "XLSX",
      "pdf": "PDF"
    },
    "units": {
      "days": "Tage"
    },
    "debug": {
      "noFlagsReturnedInThisEnvironment": "In dieser Umgebung wurden keine Flags zurückgegeben",
      "knownFlags": "Bekannte Flags",
      "rawLDFlagValues": "Rohwerte der LD-Flags"
    }
  },
  "templates": {
    "steps": {
      "dueDays": {
        "header": "Fälligkeit (Tage)",
        "tooltip": "Die Anzahl der Tage nach der Erstellung eines Ereignisses aus dieser Vorlage, bis dieser Schritt fällig wird. Der Countdown beginnt zum Zeitpunkt der Erstellung des Ereignisses.",
        "validation": {
          "range": "Geben Sie eine ganze Zahl an Tagen zwischen 0 und 100000 ein."
        }
      }
    },
    "labels": {
      "eventTemplates": "Ereignisvorlagen",
      "templateStatus": "Vorlagenstatus",
      "templateOwner": "Vorlagenbesitzer",
      "defaultAssignee": "Standard-Beauftragter",
      "defaultEventOwner": "Standard-Ereignisbesitzer",
      "defaultTimeLimit": "Standard-Zeitlimit",
      "validationStepTimeDelay": "Zeitverzögerung für Validierungsschritt",
      "timeLimitDays": "Zeitlimit (Tage)",
      "validationStepTimeDelayDays": "Zeitverzögerung für Validierungsschritt (Tage)",
      "defaultSections": "Standard-Abschnitte",
      "formSteps": "Formularschritte",
      "inSection": "Im Abschnitt"
    },
    "actions": {
      "editEventTemplate": "Ereignisvorlage bearbeiten",
      "createTemplateDraft": "Vorlagenentwurf erstellen",
      "makeEffective": "Wirksam setzen",
      "addStep": "Schritt hinzufügen",
      "deleteDraft": "Entwurf löschen",
      "changeTemplateOwner": "Vorlagenbesitzer ändern",
      "createEventTemplate": "Ereignisvorlage erstellen",
      "renameStep": "Schritt umbenennen",
      "changeValidationStepType": "Typ des Validierungsschritts ändern",
      "selectResolution": "Lösung auswählen",
      "updateTemplate": "Vorlage aktualisieren",
      "deleteStep": "Schritt löschen",
      "createTemplate": "Vorlage erstellen",
      "addSection": "Abschnitt hinzufügen",
      "editContentTemplate": "Inhaltsvorlage bearbeiten"
    },
    "statuses": {
      "draft": "Entwurf",
      "effective": "Wirksam",
      "archived": "Archiviert",
      "forApproval": "Zur Genehmigung",
      "approvalDeclined": "Genehmigung abgelehnt",
      "superseded": "Ersetzt",
      "allActiveStatuses": "Alle offenen Status"
    },
    "messages": {
      "eventTemplateCreated": "Ereignisvorlage erstellt",
      "templateCreatedWithTitle": "\"{{title}}\" wurde erstellt",
      "eventTemplateCreatedFailTitle": "Ereignisvorlage nicht erstellt",
      "makeEffectiveSuccessMessage": "Ereignisvorlage wurde wirksam gesetzt",
      "eventTemplateUpdateFailTitle": "Ereignisvorlage nicht aktualisiert",
      "changeEventTemplateOwnerSuccessMessage": "Vorlagenbesitzer aktualisiert",
      "duplicatedStepNames": "Doppelte Schrittnamen!",
      "updatesHaveBeenMadeToThisTemplate": "Änderungen an dieser Vorlage wurden vorgenommen",
      "pleaseChooseAResolution": "Bitte wählen Sie eine Lösung für die folgenden Vorlagenänderungen. Zu diesem Zeitpunkt werden keine Änderungen am Dokument vorgenommen.",
      "aPrefixWillBeAutomaticallyAdded": "Ein Präfix wird automatisch zu jedem erstellten Ereignis hinzugefügt.",
      "eachEventMustBeResolved": "Jedes Ereignis muss innerhalb der angegebenen Tage gelöst werden. Dies ist ein Standardwert und kann bei der Ereigniserstellung geändert werden.",
      "determinesHowManyDays": "Bestimmt, wie viele Tage vergehen müssen, bevor die endgültige Schrittfreigabe abgeschlossen werden kann.",
      "templateSuccessfullyUpdated": "Vorlage erfolgreich aktualisiert",
      "failedToUpdateTheTemplate": "Vorlage konnte nicht aktualisiert werden:",
      "makeThisAResolutionSection": "Als Lösungsabschnitt festlegen",
      "contentTemplateNotCreated": "Inhaltsvorlage nicht erstellt",
      "formTemplateNotCreated": "Formularvorlage nicht erstellt",
      "editContentTemplate": "Inhaltsvorlage bearbeiten",
      "editFormTemplate": "Formularvorlage bearbeiten",
      "startBuildingYourForm": "Beginnen Sie mit der Erstellung Ihres Formulars",
      "makeThisTheValidationStep": "Dies als Validierungsschritt festlegen",
      "onlyOneResolutionSectionAllowed": "Nur ein Abschnitt vom Typ \"Resolution\" ist erlaubt. Bitte ändern Sie zuerst den Typ des anderen Abschnitts.",
      "resolutionSectionDescription": "Ein Abschnitt vom Typ \"Resolution\" wird als bearbeitbares Kontrollkästchen angezeigt, um zu bestätigen, ob das Problem gelöst wurde oder nicht.",
      "optionalQualityApproverHelper": "Für Schritte, bei denen der Qualitätsgenehmiger optional ist, ist mindestens ein anderer Genehmiger erforderlich."
    },
    "modals": {
      "makeEffectiveModalHeadingText": "Vorlage wirksam setzen",
      "makeEffectiveModalSubText": "Geben Sie Ihre digitale Signatur ein, um diese Vorlage wirksam zu setzen.",
      "deleteDraftConfirmationHeader": "Entwurf löschen?",
      "deleteDraftConformationBody": "Sind Sie sicher, dass Sie diesen Entwurf löschen möchten? Ihre Änderungen werden nicht gespeichert.",
      "exportModalTitle": "Event template exportieren",
      "exportModalSubText": "Qualio exportiert event templates als PDF.",
      "exportCoverPageTitle": "Deckblatt",
      "exportCoverPageSubText": "Ein Deckblatt enthält die Eigenschaften des event templates als erste Seite des template exports.",
      "exportIncludeCoverPage": "Deckblatt einschließen"
    },
    "fields": {
      "currentEventTemplateOwnerLabel": "Aktuell",
      "reasonForChangeInputLabel": "Grund für Änderung",
      "reasonForChangePlaceholder": "Geben Sie einen Grund für die Wirksamsetzung dieser Vorlage an..."
    },
    "helpText": {
      "templateFieldControlDescription": "Legen Sie Felder fest, die Benutzer für diesen Ereignistyp erfassen sollen, oder blenden Sie irrelevante Felder aus. Pflichtfelder werden beim Schließen des Ereignisses auf Vollständigkeit geprüft.",
      "templateFieldControlDescriptionForEventCapture": "Legen Sie Felder fest, die Benutzer für diesen Ereignistyp erfassen sollen. Sie können einen Formularschritt zur Erfassung des Feldes bestimmen (Standard sind Ereigniseigenschaften). Pflichtfelder werden beim Schließen geprüft.",
      "defaultAssigneeHelper": "Bei der Erstellung wird automatisch ein Besitzer zugewiesen. Ein Standard-Beauftragter ist erforderlich, um Ereignisse automatisch via Integration zu erstellen.",
      "defaultEventOwnerHelper": "Bei der Erstellung wird automatisch ein Besitzer zugewiesen. Ein Standard-Ereignisbesitzer ist erforderlich, um Ereignisse automatisch via Integration zu erstellen.",
      "prefixHelpText": "Jedem mit dieser Vorlage erstellten Ereignis wird automatisch ein Präfix vorangestellt. Das Präfix darf nur Buchstaben und Ziffern enthalten.",
      "defaultTimeLimitDefaultHelpText": "Jedes Ereignis muss innerhalb einer bestimmten Anzahl von Tagen gelöst werden. Dies ist ein Standardwert und kann bei der Erstellung geändert werden.",
      "defaultTimeLimitEventDueDateHelpText": "Jedes Ereignis muss innerhalb einer bestimmten Anzahl von Tagen gelöst werden. Fälligkeitsdaten werden basierend auf diesem Wert berechnet.",
      "validationStepTimeDelayHelpText": "Legt fest, wie viele Tage vergehen müssen, bevor der letzte Schritt genehmigt werden kann."
    },
    "validation": {
      "emptyTitlesAreNotAllowed": "Leere Titel sind nicht zulässig",
      "duplicateTitlesAreNotAllowed": "Doppelte Titel sind nicht erlaubt"
    },
    "ckeditor": {
      "insertCodeBlock": "Codeblock einfügen",
      "insertCodeBlockCaps": "CODEBLOCK EINFÜGEN",
      "paragraph": "Absatz",
      "heading1": "Überschrift 1",
      "heading2": "Überschrift 2",
      "heading3": "Überschrift 3",
      "heading4": "Überschrift 4",
      "normal": "Normal"
    },
    "content": {
      "resolveSection": "Abschnitt '{{sectionTitle}}' ist zum Entfernen markiert. Bitte wählen Sie eine Lösung."
    }
  },
  "forms": {
    "labels": {
      "fieldTitle": "Feldtitel",
      "helpText": "Hilfetext",
      "sectionFieldTitle": "Abschnittstitel",
      "sectionDescription": "Abschnittsbeschreibung",
      "defaultContent": "Standardinhalt",
      "multiSelect": "Mehrfachauswahl",
      "optionSectionLabel": "Optionen",
      "reviewStep": "Prüfschritt"
    },
    "actions": {
      "completeForm": "Formular ausfüllen",
      "addField": "Feld hinzufügen",
      "addFormElement": "Formularelement hinzufügen",
      "createNewField": "Neues Feld erstellen",
      "chooseQualioResource": "Qualio-Ressource auswählen",
      "addHelpText": "Hilfetext hinzufügen",
      "editHelpText": "Hilfetext bearbeiten",
      "addSectionDescription": "Abschnittsbeschreibung hinzufügen",
      "editSectionDescription": "Abschnittsbeschreibung bearbeiten",
      "addDefaultContent": "Standardinhalt hinzufügen",
      "editDefaultContent": "Standardinhalt bearbeiten",
      "addOption": "Option hinzufügen",
      "startBuildingForm": "Mit der Formularerstellung beginnen",
      "editForm": "Formular bearbeiten",
      "sendForReview": "Zur Prüfung senden",
      "sendForApproval": "Zur Genehmigung senden",
      "reassignStep": "Schritt neu zuweisen",
      "manageReviewers": "Prüfer verwalten",
      "manageApprovers": "Genehmiger verwalten",
      "revertToDraft": "In Entwurf zurücksetzen",
      "markAsReviewed": "Als geprüft markieren",
      "reassignStepAction": "Schritt neu zuweisen"
    },
    "messages": {
      "noFormElementAddedYet": "Noch kein Formularelement hinzugefügt",
      "addFormElementToStartBuilding": "Fügen Sie ein Formularelement hinzu, um mit dem Erstellen Ihres Formulars zu beginnen",
      "formUpdateSuccessTitle": "Formularwerte aktualisiert",
      "formUpdateSuccessMessage": "Formular erfolgreich aktualisiert",
      "formUpdateFailedTitle": "Formular nicht aktualisiert",
      "formMissingMessage": "Das Formular konnte nicht gefunden werden",
      "formPreviewWarning": "Dies ist eine Vorschau des Formulars",
      "formPreviewDuplicateLabelWarning": "Ein oder mehrere Felder haben doppelte Bezeichnungen. Bearbeiten Sie das Formular entsprechend.",
      "noFormYet": "Noch kein Formular zur Vorschau verfügbar",
      "startFormCopy": "Beginnen wir mit der Erstellung Ihres Formulars. Damit können Sie spezifische Ereignisinformationen sammeln und später analysieren.",
      "approversUpdateSuccessTitle": "{{approverType}} aktualisiert",
      "approversUpdateSuccessMessage": "{{approverType}} für dieses Formular erfolgreich aktualisiert",
      "approversUpdateFailedTitle": "Aktualisierung der {{approverType}} fehlgeschlagen",
      "approversUpdateFailedMessage": "Ein oder mehrere {{approverType}} wurden nicht aktualisiert.",
      "atLeastOneAssigneeRequiredMessage": "Formulare im Status „{{status}}“ erfordern mindestens einen Beauftragten",
      "removingActionedApproverErrorMessage": "Bereits aktive {{approverType}} können nicht entfernt werden",
      "reviewForm": "Prüfung „{{formName}}“",
      "disabledDeleteTooltip": "Die Sichtbarkeit von {{fieldType}} ist in der Vorlage festgelegt. Deaktivieren Sie die Sichtbarkeit dort, um das Feld zu entfernen.",
      "disableRequiredTooltip": "Die Pflichtfeldeinstellung für {{fieldType}} wird in der Vorlage verwaltet.",
      "pleaseMarkThisStepAsReviewed": "Bitte markieren Sie diesen Schritt als geprüft",
      "reviewersAdded": "Prüfer hinzugefügt"
    },
    "fieldTypes": {
      "text": "Einzeiliger Text",
      "richText": "Rich-Text-Absatz",
      "date": "Datum",
      "dropdown": "Dropdown",
      "boolean": "Ja / Nein",
      "numeric": "Numerisch",
      "attachment": "Anhang",
      "document": "Dokument",
      "event": "Ereignis",
      "supplier": "Lieferant",
      "user": "Benutzer",
      "section": "Abschnitt",
      "checkbox": "Checkboxen",
      "radio": "Optionsfelder",
      "changeRequest": "Änderungsanfrage",
      "registry": "Register",
      "designControls": "Designkontrollen",
      "training": "Schulung",
      "documentTemplates": "Vorlagen",
      "eventTemplates": "Ereignisvorlagen",
      "task": "Aufgabe"
    },
    "validation": {
      "optionValueRequired": "Optionswert erforderlich",
      "optionValueTooLarge": "Optionswert muss kürzer als 512 Zeichen sein",
      "optionValueUnique": "Optionen dürfen keine doppelten Namen haben",
      "requiredFieldHelper": "Dieses Feld ist für abgeschlossene Ereignisse erforderlich",
      "formContentInvalidError": "Formularinhalt ist ungültig",
      "required": "Erforderlich"
    },
    "statusChanges": {
      "sentForReview": "Zur Prüfung gesendet",
      "sentForApproval": "Zur Genehmigung gesendet",
      "revertedToDraft": "In Entwurf zurückgesetzt",
      "cannotSendForReview": "Versand zur Prüfung nicht möglich",
      "cannotSendForApproval": "Versand zur Genehmigung nicht möglich",
      "cannotRevertToDraft": "Rücksetzung in Entwurf nicht möglich",
      "cannotUpdateTheForm": "Formular kann nicht aktualisiert werden",
      "wasSentForReview": "{{formTitle}} wurde zur Prüfung gesendet",
      "wasSentForApproval": "{{formTitle}} wurde zur Genehmigung gesendet",
      "wasRevertedToDraft": "wurde in Entwurf zurückgesetzt"
    },
    "approvers": {
      "reviewers": "Prüfer",
      "qualityApprovers": "Qualitätsgenehmiger",
      "otherApprovers": "Weitere Genehmiger",
      "approverDeclinedStepOnDate": "{{approverName}} hat diesen Schritt am {{date}} mit folgendem Kommentar abgelehnt:"
    },
    "errors": {
      "cannotSendForApprovalMissingRequiredFields": "Versand zur Genehmigung nicht möglich, da Pflichtfelder im Ereignis fehlen",
      "pleaseAddApproversBeforeSubmitting": "Bitte fügen Sie Genehmiger hinzu, bevor Sie zur Genehmigung einreichen.",
      "missingRequiredFieldsOnEvent": "Einige Pflichtfelder im Ereignis fehlen.",
      "toViewTheRequiredEventFields": "um die erforderlichen Ereignisfelder anzuzeigen."
    }
  },
  "events": {
    "labels": {
      "eventProperties": "Ereigniseigenschaften",
      "relatedEvents": "Zugehörige Ereignisse",
      "relatedDocuments": "Zugehörige Dokumente",
      "sourceEvent": "Quellereignis",
      "escalatedTo": "Eskaliert an",
      "relatedSuppliers": "Zugehörige Lieferanten",
      "events": "Ereignisse",
      "tasks": "Aufgaben",
      "products": "Produkte",
      "collaborators": "Mitwirkende"
    },
    "actions": {
      "createEvent": "Ereignis erstellen",
      "editEvent": "Ereignis bearbeiten",
      "openEvent": "Ereignis öffnen",
      "cancelEvent": "Ereignis abbrechen",
      "closeEarly": "Vorzeitig schließen",
      "updateEvent": "Ereignis aktualisieren",
      "updateTags": "Tags aktualisieren",
      "escalateAndCreateNewEvent": "Eskalieren und neues Ereignis erstellen",
      "exportEvent": "Ereignis exportieren",
      "changeOwner": "Besitzer ändern",
      "changeDueDate": "Fälligkeitsdatum ändern",
      "updateEventProperties": "Ereigniseigenschaften aktualisieren",
      "exportListAsXLSX": "Liste als XLSX exportieren",
      "exportListAsPDF": "Liste als PDF exportieren",
      "approveStep": "Schritt genehmigen",
      "declineStep": "Schritt ablehnen",
      "reopenEvent": "Ereignis wieder öffnen",
      "closeEvent": "Ereignis schließen"
    },
    "statuses": {
      "open": "Offen",
      "closed": "Geschlossen",
      "imported": "Importiert",
      "rejected": "Abgelehnt",
      "canceled": "Abgebrochen"
    },
    "messages": {
      "eventMissingMessage": "Ereignis konnte nicht gefunden werden",
      "eventAcceptedMessage": "Sie haben dieses Ereignis akzeptiert",
      "eventRejectedMessage": "Sie haben dieses Ereignis abgelehnt",
      "eventCanceledMessage": "Sie haben dieses Ereignis abgebrochen",
      "defaultOwnerNoPermissionTitle": "Standardbesitzer hat keine Berechtigung",
      "defaultOwnerNoPermissionMessage": "Der Standardbesitzer verfügt nicht über die erforderlichen Rechte",
      "defaultAssigneeNoPermissionTitle": "Standard-Beauftragter hat keine Berechtigung",
      "defaultAssigneeNoPermissionMessage": "Der Standard-Beauftragte verfügt nicht über die erforderlichen Rechte",
      "eventPropertiesNotUpdatedError": "Ereigniseigenschaften nicht aktualisiert",
      "missingRequiredFields": "Pflichtfelder fehlen",
      "temporarilyUnableToRetrieveAllEventProperties": "Eigenschaften können vorübergehend nicht vollständig abgerufen werden",
      "theTeamHasBeenNotifiedPleaseRefreshOrTryAgainLater": "Das Team wurde benachrichtigt. Bitte laden Sie die Seite neu.",
      "theFollowingEventFieldsWillBeCopiedToTheNewEvent": "Die folgenden Felder werden in das neue Ereignis kopiert:",
      "youCanEditEventFieldsAfterCreation": "Sie können die Felder nach der Erstellung bearbeiten.",
      "provideAnyInformationYouHave": "Geben Sie alle verfügbaren Informationen an",
      "theFollowingEventFieldsWillBeCopied": "Die folgenden Ereignisfelder werden in das neue Ereignis kopiert:",
      "removedFromProperties": "Aus Eigenschaften entfernt:",
      "addedToProperties": "Zu Eigenschaften hinzugefügt:",
      "requiredColon": "Erforderlich:",
      "notRequired": "Nicht erforderlich:",
      "thisActionAffectsStepApprovalStatus": "Diese Aktion beeinflusst den Genehmigungsstatus des Schritts",
      "manageApproverType": "{{approverType}} verwalten",
      "approvalDeclined": "Genehmigung abgelehnt",
      "manageReviewers": "Prüfer verwalten",
      "manageQualityApprovers": "Qualitätsgenehmiger verwalten",
      "manageOtherApprovers": "Weitere Genehmiger verwalten",
      "manageApprovers": "Genehmiger verwalten",
      "selectUsersForReviewerFeedback": "Wählen Sie Benutzer aus, die Feedback und Vorschläge zum Ereignisformular geben sollen.",
      "selectUsersForQualityApproval": "Wählen Sie Benutzer aus, die für die endgültige Ereignisformular‑Genehmigung und Freigabe erforderlich sind.",
      "selectUsersForOtherApproval": "Wählen Sie Benutzer aus, die für die endgültige Genehmigung und Freigabe des Ereignisformulars verantwortlich sind.",
      "selectUsersForApproval": "Wählen Sie Benutzer aus, die für die endgültige Genehmigung und Freigabe des Ereignisformulars verantwortlich sind.",
      "selectProductForEvent": "Wählen Sie das mit diesem Ereignis verknüpfte Produkt aus.",
      "selectRootCauseForEvent": "Wählen Sie die Ursache dieses Ereignisses aus.",
      "riskCalculationDescription": "Das Risiko wird anhand der Wahrscheinlichkeits- und Schweregradfelder eines Ereignisses berechnet. ",
      "linkSuppliersToEvent": "Verknüpfen Sie Lieferanten, die mit diesem Ereignis zusammenhängen. ",
      "canceledOn": "Abgebrochen am",
      "rejectedOn": "Abgelehnt am",
      "closedEarlyOn": "Vorzeitig geschlossen am",
      "cancelationReason": "Abbruchgrund",
      "rejectionReason": "Ablehnungsgrund",
      "closeReason": "Schließgrund",
      "missingQualityTypeApprover": "Qualitäts-Genehmiger fehlt",
      "requiredFieldsMustBeCompletedBeforeApprovalAndClosure": "Die folgenden Pflichtfelder müssen ausgefüllt werden, bevor dieses Ereignis genehmigt und geschlossen werden kann:",
      "editEventToFillMissingRequiredFields": "Aktualisieren Sie das Ereignis, um die fehlenden Pflichtfelder auszufüllen.",
      "removingApproversWarning": "Das Entfernen dieser Genehmiger ändert den Schritt von 'Zur Genehmigung' auf 'Genehmigt'.",
      "manageCollaborators": "Mitwirkende verwalten",
      "selectUsersForCollaboration": "Wählen Sie Benutzer aus, die Ereignisschritte abschließen oder zuweisen sowie Aufgaben erstellen und verwalten können.",
      "collaboratorsAdded": "Mitwirkende hinzugefügt",
      "collaboratorsRemoved": "Mitwirkende entfernt"
    },
    "modals": {
      "eventAcceptSubText": "Geben Sie Ihre digitale Signatur ein, um das Ereignis zu akzeptieren",
      "eventCancelSubText": "Diese Aktion bricht alle Schritte ab und markiert das Ereignis als abgebrochen.",
      "eventRejectSubText": "Geben Sie Ihre digitale Signatur ein, um das Ereignis abzulehnen",
      "approveStepSubText": "Geben Sie Ihre digitale Signatur ein, um den Schritt zu genehmigen",
      "declineStepSubText": "Geben Sie Ihre digitale Signatur ein, um den Schritt abzulehnen",
      "closeEarlySubText": "Diese Aktion wird alle Ereignisschritte abbrechen und das Ereignis als geschlossen markieren.",
      "reopenEventSubText": "Möchten Sie dieses Ereignis wirklich wieder öffnen?",
      "eventSuccessfullyClosed": "Ereignis {{eventCode}} erfolgreich geschlossen",
      "eventSuccessfullyReopened": "Ereignis {{eventCode}} erfolgreich wieder geöffnet",
      "changeDueDateReasonPlaceholder": "Geben Sie einen Grund für die Änderung des Fälligkeitsdatums an...",
      "dueDateSuccessfullyUpdated": "Fälligkeitsdatum erfolgreich aktualisiert",
      "collaboratorsSuccessfullyUpdated": "Mitwirkende erfolgreich aktualisiert"
    },
    "create": {
      "provideRequiredInformationToCreateAnEvent": "Geben Sie die erforderlichen Informationen an, um ein Ereignis zu erstellen."
    },
    "tabs": {
      "details": "Details"
    }
  },
  "tasks": {
    "labels": {
      "taskStatus": "Aufgabenstatus",
      "assignTo": "Zuweisen an",
      "reassignTo": "Neu zuweisen an"
    },
    "actions": {
      "createTask": "Aufgabe erstellen",
      "completeTask": "Aufgabe abschließen",
      "reopenTask": "Aufgabe wieder öffnen",
      "completeStep": "Schritt abschließen",
      "actionStep": "Aktionsschritt",
      "revertStep": "Schritt zurücksetzen",
      "revertStepCompletion": "Schrittabschluss rückgängig machen?",
      "assignStep": "Schritt zuweisen",
      "reassign": "Neu zuweisen",
      "assign": "Zuweisen",
      "comment": "Kommentieren"
    },
    "modals": {
      "signOffToRevertCompletion": "Abzeichnen, um den Abschluss des Schritts \"{{stepLabel}}\" rückgängig zu machen",
      "stepCompletionWasReverted": "Der Abschluss des Schritts \"{{stepLabel}}\" wurde rückgängig gemacht",
      "signOffToCompleteStep": "Abzeichnen, um den Schritt \"{{stepLabel}}\" abzuschließen",
      "stepWasMarkedComplete": "Der Schritt \"{{stepLabel}}\" wurde als abgeschlossen markiert"
    },
    "messages": {
      "userReassigned": "Benutzer neu zugewiesen",
      "userReassignedSuccessfully": "Benutzer erfolgreich neu zugewiesen.",
      "completeFormAndSendForReview": "Füllen Sie das Formular aus und senden Sie es zur Prüfung und Genehmigung, sobald es bereit ist.",
      "noFormAssociatedWithStep": "Mit diesem Schritt ist kein Formular verknüpft.",
      "thisFieldRequiredBeforeClosing": "Dieses Feld ist vor dem Schließen des Ereignisses erforderlich.",
      "cannotSendForApprovalUntil": "Diese Lösung kann nicht zur Genehmigung gesendet werden bis",
      "createAndAssignTasks": "Erstellen Sie Aufgaben, weisen Sie sie zu und verfolgen Sie ihren Fortschritt.",
      "noTasksAssociatedWithStep": "Mit diesem Schritt sind keine Aufgaben verbunden."
    }
  },
  "products": {
    "confirmations": {
      "deleteProductConfirmation": "Sind Sie sicher, dass Sie „{{productName}}“ löschen möchten?"
    }
  },
  "rootCauses": {
    "labels": {
      "rootCauses": "Ursachen"
    },
    "confirmations": {
      "deleteRootCauseConfirmation": "Sind Sie sicher, dass Sie die Ursache „{{rootCauseName}}“ löschen möchten?"
    }
  },
  "search": {
    "errors": {
      "searchFailed": "Suchergebnisse konnten nicht abgerufen werden"
    }
  }
}
